/* eslint-disable react/prop-types */
import React, { useState, useEffect } from 'react'
import Button from '@material-ui/core/Button'
import Input from '../../components/input'
import Dialog from '@material-ui/core/Dialog'
import useObjectState from '../../../hooks/useObjectState'
import { Box, Grid, CircularProgress, Typography } from '@material-ui/core'
import styled from 'styled-components'
import currencyParser from '../../../helpers/currency'
import { requires } from '../../../helpers/validateform'
import { Alert } from '@material-ui/lab'
import { db } from '../../../modules/firebase'

const Container = styled.div`
  width: 500px;
  padding: 80px;
  box-sizing: border-box;
  @media screen and (max-width:1000px) {
    width: 400px;
    padding: 30px;
  }
  @media screen and (max-width:500px) {
    width: 80vw;
    padding: 30px;
  }
`

export default function FormDialog (props) {
  const [state, setState] = useObjectState(props.data || {})
  const [currentView, setCurrentView] = useState('form') // form, loading
  const [errors, setErrors] = useState([])

  const handleChange = ({ name, value }) => {
    setState({ [name]: value })
  }

  const handleSave = async () => {
    const errors = requires(state, ['shippingCost'])
    if (errors.length) return setErrors(errors)
    setCurrentView('loading')
    await db.doc('config/main').update({
      shippingCost: state.shippingCost
    })
    props.onClose()
    if (props.onSuccess) props.onSuccess()
    setCurrentView('form')
  }

  const removeError = ({ name }) => {
    if (errors.includes(name)) {
      setErrors(errors.filter(error => error !== name))
    }
  }

  // sync data width props
  useEffect(() => {
    if (props.shippingCost) {
      setState({ shippingCost: props.shippingCost })
    }
  }, [props.shippingCost])

  return (

    <Dialog open={props.open} onClose={props.onClose}>
      <Container>
        {currentView === 'form' && (
          <>
            <Typography variant='h6' color='primary'>Costo toma a domicilio</Typography>
            <div>
              {!!errors.length && (
                <Box pt={2}>
                  <Alert severity='error'>El costo es requerido</Alert>
                </Box>
              )}
              <Box pt={4}>
                <Input
                  removeError={removeError}
                  errors={errors}
                  fullWidth
                  type='text'
                  margin='normal'
                  size='small'
                  placeholder='Costo'
                  name='shippingCost'
                  value={state.shippingCost ? currencyParser.toCurrency(state.shippingCost) : ''}
                  onChange={({ name, value }) => handleChange({ name, value: currencyParser.toNumber(value) })}
                />
              </Box>
              <Box mt={4}>
                <Grid container spacing={1}>
                  <Grid item xs={6}>
                    <Button onClick={props.onClose} style={{ textTransform: 'none' }} fullWidth variant='outlined' color='primary'>
                      Cancelar
                    </Button>
                  </Grid>
                  <Grid item xs={6}>
                    <Button onClick={handleSave} style={{ textTransform: 'none' }} fullWidth variant='contained' color='primary'>
                      Guardar
                    </Button>
                  </Grid>
                </Grid>
              </Box>
            </div>
          </>
        )}
        {currentView === 'loading' && (
          <Grid container justify='center' alignItems='center' style={{ minHeight: '200px' }}>
            <CircularProgress />
          </Grid>
        )}
      </Container>
    </Dialog>
  )
}
